// extracted by mini-css-extract-plugin
module.exports = {"dropdowncontainer":"Dropdown_dropdowncontainer__Ftzsh","dropdownItem":"Dropdown_dropdownItem__aFwUx","divider":"Dropdown_divider__QLbNO","icon":"Dropdown_icon__a1pUv"};